export default __webpack_public_path__ + "images/models/6e0b4855f2f957931c9fb021e759e0b8.glb";